import SessionItemView from './SessionItemView';

export default SessionItemView;
